// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__GeneralSwatchSettings .BC-Container__Swatch {
  margin-top: 24px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__Swatch .Polaris-Banner--statusInfo {
  border: 1px solid #95C9B4;
  background-color: #F7FDFC;
  padding-right: 20px;
  padding-bottom: 0;
}


.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-EmptySwatch {
  text-align: center;
  padding: 2.5rem 0;
  margin: 0;
}

.BC-Page__GeneralSwatchSettings .Polaris-Banner>.Polaris-Box {
  display: none;
}

.BC-Page__GeneralSwatchSettings .Polaris-Banner .banner-title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__GeneralSwatchSettings .Polaris-Banner .banner-content {
  display: flex;
  align-items: flex-start;
}

.BC-Page__GeneralSwatchSettings .Polaris-Banner .banner-content .wave {
  position: absolute;
  z-index: 9;
  bottom: 0;
  right: 0;
}

.BC-Page__GeneralSwatchSettings .Polaris-Card .Polaris-Card__Section {
  padding: 24px 20px;
}

.BC-Page__GeneralSwatchSettings .Polaris-Card .Polaris-Card__Section {
  padding: 24px 20px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-Card__Header {
  padding: 16px;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Cell:first-child .Polaris-DataTable__TooltipContent {
  width: 100%;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header,
.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .BC-Container__SwatchSettingsTable__Header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .BC-Container__SwatchSettingsTable__Header .search {
  flex-grow: 1;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  width: 100%;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack .Polaris-Stack__Item {
  flex-grow: 1;
  width: 100%;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__TableRow .Polaris-Stack .Polaris-Stack__Item {
  flex-grow: 1;
  width: auto;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack .Polaris-Stack__Item .swatchActionList {
  margin: 0;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack .Polaris-Stack__Item.Polaris-Stack__Item--fill {
  display: none;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell .Polaris-Stack {
  margin: 0;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell .Polaris-Stack .Polaris-Stack__Item {
  margin: 0;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}


.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh svg path {
  fill: #2C6ECB;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh {
  color: #2C6ECB;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh.btn-refresh--loading svg {
  -webkit-animation: spin 2s linear infinite;
  -moz-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}


.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(2) {
  width: 80px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell:nth-child(1) .Polaris-SkeletonDisplayText__DisplayText {
  width: 100%;
  max-width: 50%;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell:nth-child(1) {
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 0 16px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell:nth-child(2) {
  text-align: center;
  padding: 14px 26px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__TableRow>.Polaris-DataTable__Cell:first-child {
  padding: 0;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__TableRow>.Polaris-DataTable__Cell:first-child .option-name {
  padding: 19px 0;
  cursor: pointer;
  width: 100%;
  text-transform: capitalize;
}


.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__TableRow .Polaris-Button {
  width: 28px;
  height: 28px;
  padding: 0;
  min-width: auto;
  min-height: auto;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child .Polaris-Stack__Item {
  max-width: 100%;
}


.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table .Polaris-DataTable__Icon {
  display: none;
}


.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header {
  padding: 16px 20px;
  border-bottom: 1px solid #E1E3E5;
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell--header {
  font-weight: 600;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header .Polaris-LegacyStack {
  width: 100%;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header .Polaris-LegacyStack>.Polaris-LegacyStack__Item:first-child {
  display: none;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header .Polaris-LegacyStack>.Polaris-LegacyStack__Item {
  width: 100%;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable {
  margin-top: 40px !important;
}

.BC-Page__GeneralSwatchSettings .Polaris-Banner--statusCritical {
  margin-top: 40px !important;
  margin-bottom: -8px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell {
  padding: 0.9375rem 0.78125rem;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable tbody .Polaris-DataTable__Cell {
  border-top: 1px solid var(--p-divider);
  border-bottom: none;
  white-space: normal;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable tbody tr:first-child .Polaris-DataTable__Cell {
  border-top: none;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell.sortable-heading,
.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .searchOption .item .remove {
  cursor: pointer;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell.sortable-heading:hover {
  color: var(--p-action-primary);
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell.sortable-heading>span {
  display: inline-flex;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:first-child {
  width: 64px;
  padding-left: 1.25rem;
  padding-right: 0;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:nth-child(2) {
  width: 21%;
  padding-left: 0.9375rem;
  word-break: break-word;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:nth-child(3) {
  width: 21%;
  vertical-align: top;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:nth-child(4) {
  padding-right: 1.2rem;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Table--non-color .Polaris-DataTable__Cell:first-child {
  width: 200px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Table--non-color .Polaris-DataTable__Cell:nth-child(2) {
  width: 220px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Table--non-color .Polaris-DataTable__Cell:nth-child(3) {
  width: auto;
  padding-right: 1.2rem;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .actionsGroup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .swatch-color {
  width: 32px;
  height: 32px;
  border: 1px solid var(--p-divider);
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-TextField__Input {
  padding-right: 0.6875rem;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .selectedColor {
  background-color: #fff;
  z-index: 417;
  width: 25px;
  height: 25px;
  margin-right: 0;
  border-radius: 3px;
  margin-left: 0.75rem;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable #error-imageError .Polaris-InlineError__Icon {
  display: none;
}

.BC-Page__GeneralSwatchSettings .BC-EmptySwatch {
  margin: 2.5rem 0;
  text-align: center;
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .colorCode .Polaris-Stack .Polaris-Stack__Item {
  max-width: calc(50% - 1rem);
}

.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .sort-icon {
  position: relative;
  top: 1px;
}

.BC-Page__GeneralSwatchSettings~#PolarisPortalsContainer .swatchActionList__content {
  padding: 8px 16px;
}

.BC-Page__GeneralSwatchSettings~#PolarisPortalsContainer .swatchActionList__content__options {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BC-Page__GeneralSwatchSettings .pagination {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  position: relative;
}

.BC-Page__GeneralSwatchSettings .pagination .actionsGroup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.BC-Page__GeneralSwatchSettings .btn-upload .Polaris-Button {
  max-height: 36px;
}

.BC-Page__GeneralSwatchSettings .swatch-image-select {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__GeneralSwatchSettings .swatch-image-select--start {
  align-items: flex-start;
}

.BC-Page__GeneralSwatchSettings .swatch-image-select>div:first-child {
  width: 100%;
}

.modal-upload-image-swatch .Polaris-DropZone {
  border: 1px dashed #BABFC3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* padding: px 0; */
}

.modal-upload-image-swatch .Polaris-DropZone-FileUpload__Action {
  background: #E5EFFD;
  padding: 6px;
  color: #1F5199;
  font-weight: 600;
  font-size: 12px;
}

.modal-upload-image-swatch .modal-upload-image-swatch__file {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.modal-upload-image-swatch .modal-uploaded-image {
  margin-top: 16px;
}

.modal-upload-image-swatch .modal-upload-image-swatch__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}


@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/general-swatch.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,kCAAkC;AACpC;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,yBAAyB;EAC3B;AACF","sourcesContent":[".BC-Page__GeneralSwatchSettings .BC-Container__Swatch {\n  margin-top: 24px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__Swatch .Polaris-Banner--statusInfo {\n  border: 1px solid #95C9B4;\n  background-color: #F7FDFC;\n  padding-right: 20px;\n  padding-bottom: 0;\n}\n\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-EmptySwatch {\n  text-align: center;\n  padding: 2.5rem 0;\n  margin: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Banner>.Polaris-Box {\n  display: none;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Banner .banner-title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Banner .banner-content {\n  display: flex;\n  align-items: flex-start;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Banner .banner-content .wave {\n  position: absolute;\n  z-index: 9;\n  bottom: 0;\n  right: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Card .Polaris-Card__Section {\n  padding: 24px 20px;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Card .Polaris-Card__Section {\n  padding: 24px 20px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-Card__Header {\n  padding: 16px;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Cell:first-child .Polaris-DataTable__TooltipContent {\n  width: 100%;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header,\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .BC-Container__SwatchSettingsTable__Header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .BC-Container__SwatchSettingsTable__Header .search {\n  flex-grow: 1;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack {\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap;\n  width: 100%;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack .Polaris-Stack__Item {\n  flex-grow: 1;\n  width: 100%;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__TableRow .Polaris-Stack .Polaris-Stack__Item {\n  flex-grow: 1;\n  width: auto;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack .Polaris-Stack__Item .swatchActionList {\n  margin: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Stack .Polaris-Stack__Item.Polaris-Stack__Item--fill {\n  display: none;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell .Polaris-Stack {\n  margin: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell .Polaris-Stack .Polaris-Stack__Item {\n  margin: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh svg path {\n  fill: #2C6ECB;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh {\n  color: #2C6ECB;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .BC-Container__SwatchTable__Header .btn-refresh.btn-refresh--loading svg {\n  -webkit-animation: spin 2s linear infinite;\n  -moz-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table thead .Polaris-DataTable__Cell:nth-child(2) {\n  width: 80px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell:nth-child(1) .Polaris-SkeletonDisplayText__DisplayText {\n  width: 100%;\n  max-width: 50%;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell:nth-child(1) {\n  display: flex;\n  align-items: center;\n  min-height: 60px;\n  padding: 0 16px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table tbody .Polaris-DataTable__Cell:nth-child(2) {\n  text-align: center;\n  padding: 14px 26px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__TableRow>.Polaris-DataTable__Cell:first-child {\n  padding: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__TableRow>.Polaris-DataTable__Cell:first-child .option-name {\n  padding: 19px 0;\n  cursor: pointer;\n  width: 100%;\n  text-transform: capitalize;\n}\n\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__TableRow .Polaris-Button {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  min-width: auto;\n  min-height: auto;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child .Polaris-Stack__Item {\n  max-width: 100%;\n}\n\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchTable .Polaris-DataTable__Table .Polaris-DataTable__Icon {\n  display: none;\n}\n\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #E1E3E5;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell--header {\n  font-weight: 600;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header .Polaris-LegacyStack {\n  width: 100%;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header .Polaris-LegacyStack>.Polaris-LegacyStack__Item:first-child {\n  display: none;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-Card__Header .Polaris-LegacyStack>.Polaris-LegacyStack__Item {\n  width: 100%;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable {\n  margin-top: 40px !important;\n}\n\n.BC-Page__GeneralSwatchSettings .Polaris-Banner--statusCritical {\n  margin-top: 40px !important;\n  margin-bottom: -8px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell {\n  padding: 0.9375rem 0.78125rem;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable tbody .Polaris-DataTable__Cell {\n  border-top: 1px solid var(--p-divider);\n  border-bottom: none;\n  white-space: normal;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable tbody tr:first-child .Polaris-DataTable__Cell {\n  border-top: none;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell.sortable-heading,\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .searchOption .item .remove {\n  cursor: pointer;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell.sortable-heading:hover {\n  color: var(--p-action-primary);\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell.sortable-heading>span {\n  display: inline-flex;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:first-child {\n  width: 64px;\n  padding-left: 1.25rem;\n  padding-right: 0;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:nth-child(2) {\n  width: 21%;\n  padding-left: 0.9375rem;\n  word-break: break-word;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:nth-child(3) {\n  width: 21%;\n  vertical-align: top;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Cell:nth-child(4) {\n  padding-right: 1.2rem;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Table--non-color .Polaris-DataTable__Cell:first-child {\n  width: 200px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Table--non-color .Polaris-DataTable__Cell:nth-child(2) {\n  width: 220px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-DataTable__Table--non-color .Polaris-DataTable__Cell:nth-child(3) {\n  width: auto;\n  padding-right: 1.2rem;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .actionsGroup {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .swatch-color {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--p-divider);\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .Polaris-TextField__Input {\n  padding-right: 0.6875rem;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .selectedColor {\n  background-color: #fff;\n  z-index: 417;\n  width: 25px;\n  height: 25px;\n  margin-right: 0;\n  border-radius: 3px;\n  margin-left: 0.75rem;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable #error-imageError .Polaris-InlineError__Icon {\n  display: none;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-EmptySwatch {\n  margin: 2.5rem 0;\n  text-align: center;\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .colorCode .Polaris-Stack .Polaris-Stack__Item {\n  max-width: calc(50% - 1rem);\n}\n\n.BC-Page__GeneralSwatchSettings .BC-Container__SwatchSettingsTable .sort-icon {\n  position: relative;\n  top: 1px;\n}\n\n.BC-Page__GeneralSwatchSettings~#PolarisPortalsContainer .swatchActionList__content {\n  padding: 8px 16px;\n}\n\n.BC-Page__GeneralSwatchSettings~#PolarisPortalsContainer .swatchActionList__content__options {\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.BC-Page__GeneralSwatchSettings .pagination {\n  margin-top: 24px;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.BC-Page__GeneralSwatchSettings .pagination .actionsGroup {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n}\n\n.BC-Page__GeneralSwatchSettings .btn-upload .Polaris-Button {\n  max-height: 36px;\n}\n\n.BC-Page__GeneralSwatchSettings .swatch-image-select {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__GeneralSwatchSettings .swatch-image-select--start {\n  align-items: flex-start;\n}\n\n.BC-Page__GeneralSwatchSettings .swatch-image-select>div:first-child {\n  width: 100%;\n}\n\n.modal-upload-image-swatch .Polaris-DropZone {\n  border: 1px dashed #BABFC3;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  /* padding: px 0; */\n}\n\n.modal-upload-image-swatch .Polaris-DropZone-FileUpload__Action {\n  background: #E5EFFD;\n  padding: 6px;\n  color: #1F5199;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.modal-upload-image-swatch .modal-upload-image-swatch__file {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.modal-upload-image-swatch .modal-uploaded-image {\n  margin-top: 16px;\n}\n\n.modal-upload-image-swatch .modal-upload-image-swatch__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n\n@-moz-keyframes spin {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
